module.exports = __webpack_public_path__ + "img/layout5_preview.8572a7bd.jpg";